import { Component } from '@verndale/core';
import $ from 'jquery';

class ModelsForBrand extends Component {
  setupDefaults() {
    this.dom = {};
    this.initModels();
  }

  addListeners() {}

  initModels() {
    const $modelListWithFilterSection = $('section.models-for-brand.has-filter');
    if ($modelListWithFilterSection.length) {
      const $modelFilters = $modelListWithFilterSection.find('.sb-select');
        const $modelContainers = $modelListWithFilterSection.find(
          '.model-list div.model'
        );
        const $clearFilters = $modelListWithFilterSection.find('.clear-filters');

        // eslint-disable-next-line no-inner-declarations
        function resetModels() {
          $modelFilters.val('');
          $modelContainers.show();
          $clearFilters.removeClass('active');
        }

        $modelFilters.change(function (e) {
          e.preventDefault();
          const $this = $(this);
          /* eslint-disable no-unused-vars */
          const rel = $this.attr('rel');
          /* eslint-enable no-unused-vars */
          /* eslint-disable array-callback-return */
          const attributeSelectors = $modelFilters
            .map((i, el) => {
              const $el = $(el);
              if ($el.val() !== '') {
                return `[data-${  $el.attr('rel')  }*="|${  $el.val()  }|"]`;
              }
            })
            .get();

        if (attributeSelectors && attributeSelectors.length) {
          $modelContainers.hide().filter(attributeSelectors.join('')).show();
          $clearFilters.addClass('active');
        } else {
          resetModels();
        }
      });

      $modelListWithFilterSection.find('.clear-filters').click((e) => {
        e.preventDefault();
        resetModels();
      });
    }
  }
}

export default ModelsForBrand;
